import React from 'react';
import { Modal } from 'antd';
import MemoForm from './MemoForm';

const MemoModal = ({
    isOpen,
    handleClose,
    memo,
    content,
    setContent,
    memoContentMode,
    setMemoContentMode,
    financialYears,
    structures,
    units,
    fyear,
    setFyear,
    category,
    setCategory,
    amount,
    setAmount,
    unit,
    setUnit,
    file,
    setFile,
    memoType,
    setMemoType,
    handleSubmit,
    handleUpdate,
    titleRef,
    memoReference,
    staffId
}) => {
    return (
        <Modal
            centered
            open={isOpen}
            title={Object.keys(memo).length < 1 ? "Create A New Memo" : "Edit memo"}
            footer={null}
            onCancel={handleClose}
            width={"80%"}
        >
            <div style={{
                marginTop: "3em",
                maxHeight: "70vh",
                overflowY: "scroll",
                overflowX: 'hidden',
                paddingLeft: "1em",
                paddingRight: "1em"
            }}>
                <MemoForm
                    key={memo?.id ?? 'create'}
                    memo={memo}
                    content={content}
                    setContent={setContent}
                    memoContentMode={memoContentMode}
                    setMemoContentMode={setMemoContentMode}
                    financialYears={financialYears}
                    structures={structures}
                    units={units}
                    fyear={fyear}
                    setFyear={setFyear}
                    category={category}
                    setCategory={setCategory}
                    amount={amount}
                    setAmount={setAmount}
                    unit={unit}
                    setUnit={setUnit}
                    file={file}
                    setFile={setFile}
                    memoType={memoType}
                    setMemoType={setMemoType}
                    handleSubmit={handleSubmit}
                    handleUpdate={handleUpdate}
                    titleRef={titleRef}
                    memoReference={memoReference}
                    staffId={staffId}
                />
            </div>
        </Modal>
    );
};

export default MemoModal;
